<template>
<el-row :gutter="20">
  <el-col :span="24" :offset="0">
  <h2>{{award.name}}</h2>
  <h1>{{msg}}</h1>
  <el-table :data="data" border style="width: 100%" @selection-change="handleSelectionChange">
    <el-table-column type="selection" width="55"></el-table-column>
    <el-table-column prop="awardsorder" label="排名"></el-table-column>
    <el-table-column prop="qname" label="企业名称"></el-table-column>
    <el-table-column v-if="(this.$route.params.id == 3)" prop="lcode" label="企业代码"></el-table-column>
  </el-table>
  <div class="block">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-sizes="[countPerPage, 100, 200, 400]"
      :page-size="countPerPage"
      layout="total,sizes, prev, pager, next"
      :total="total">
    </el-pagination>
  </div>


  </el-col>

</el-row>
</template>
<script>
export default{
  name: 'thissub',
  data (){
    return {
        msg: '',
        award: {},
        data: [],
        multipleSelection: [],
        total: 0,
        countPerPage: 10,
        currentPage: 1,
        yearOptions: [{
            value: '2017',
            label: '2017'
          },
          {
            value: '2016',
            label: '2016'
          }
        ],
        year:'2017',
        form:{}, //添加记录的通用属性
        isadd: false,
        csvValue:[],
        getListParams: {}
      }
  },
  mounted: function(){
    this.form.awardId = this.$route.params.id;  //获取上级奖项id
    this.form.subid = this.$route.params.subid; //获取本奖项id
    this.form.year = this.year;
    this.$nextTick(function () {
        this.$http.get('/api/awards/getawardsdetail',{params: {id: this.$route.params.id}}).then(    // 本奖项上级奖项明细
          response => {
            console.log(response.body);
            var d = response.body
            this.award = d.award;
            this.form.aname = d.award.name;  //获取上级奖项名称
          },
          response => {
            console.log('failed');
          }
        )  

        this.$http.get('/api/awards/getsublist',{params: {id: this.$route.params.subid,awardId: this.$route.params.id}}).then(response => { //获取子榜单信息
          console.log(response.body);
          this.msg = response.body[0].subname;
          this.form.subname = response.body[0].subname;  //获取本奖项名称
        },
        response => {
          console.log('failed');
        })

        //获取企业列表
        this.getListParams = {   //条件
                params : {
                      where:{
                          awardId: this.$route.params.id, 
                          subid: this.$route.params.subid,
                          year: this.form.year
                      }, 
                      countPerPage: this.countPerPage, 
                      currentPage: this.currentPage
                }
        };

        this.$http.get('/api/awards/thisdata',this.getListParams).then(  //企业列表
            response => {
              this.data = response.body.listArr;
              this.total = response.body.count;
            },
            response => {
              console.log('failed');
            }
          );
    });
  },
  watch:{
    year:{
            handler:function(val,oldval){
                this.form.year = val;
                this.getListParams = {
                  params : {
                        where:{
                            awardId: this.$route.params.id, 
                            subid: this.$route.params.subid,
                            year: this.form.year
                        }, 
                        countPerPage: this.countPerPage, 
                        currentPage: this.currentPage
                  }
                };

                this.$http.get('/api/awards/thisdata',this.getListParams).then(  //企业列表
                  response => {
                    this.data = response.body.listArr;
                    this.total = response.body.count;
                  },
                  response => {
                    console.log('failed');
                  }
                );
          },
            deep:true//对象内部的属性监听，也叫深度监听
        }
  },
  methods: {
      add () {
          this.isadd = true;
      },
      save () {
        this.form.aname = this.award.name;
        this.form.subname = this.msg;
        this.form.awardId = this.award.id;
        this.form.subid = this.$route.params.subid;
        this.$http.post('api/awards/addcompany', this.form).then( //添加获奖企业
          response => {
            console.log(response.body);
            this.data.push({awardsorder: this.form.awardsorder, qname: this.form.qname});
            this.form = {awardsorder:'',qname:''};
          }
        )
      },
      daoru () {
              this.$http.post('api/awards/insertMore', this.csvValue).then(  //插入多条数据
                    response => {
                    console.log(response);
                  }
                );
              },
              csvfileChange(e) { //上传csv并插入
              var that = this;
              var fReader = new FileReader();
                  fReader.readAsDataURL(e.target.files[0]);
                  fReader.onload = function(evt){
                    var data = evt.target.result;
                      var encoding = checkEncoding( data );
                      Papa.parse( e.target.files[0], {
                          header: true,
                          download: true,
                          encoding: encoding,
                          complete: function(results) {   // UTF8 \r\n与\n混用时有可能会出问题
                            var res = results.data;
                            var arrRes = [];
                            if( res[ res.length-1 ] == ""){ //去除最后的空行
                              res.pop();
                            }
                            for(var i = 0; i < res.length; i++){
                              arrRes[i] = $.extend(res[i], that.form);
                            }
                            console.log(arrRes);
                            that.csvValue = arrRes;
                          }
                      });
                  }
              },
              handleSelectionChange(val) {
                this.multipleSelection = val;
              },
              deleteAll() {
                this.$http.post('api/awards/deleteAll', this.multipleSelection).then(
                  response => {
                    console.log(response.body.text);
                  }
                )

              },
              handleSizeChange(val) {  //每页显示多少条
                this.countPerPage = val;
                this.getListParams = {
                    params : {
                              where:{
                                  awardId: this.$route.params.id, 
                                  subid: this.$route.params.subid,
                                  year: this.form.year
                              }, 
                              countPerPage: this.countPerPage, 
                              currentPage: this.currentPage
                            }
                };
                this.$http.get('/api/awards/thisdata',this.getListParams).then(
                    response => {
                          this.data = response.body.listArr;
                          this.total = response.body.count;
                    },
                    response => {
                      console.log('failed');
                    }
                  );

              },
              handleCurrentChange(val) {
                this.currentPage = val;
                this.getListParams = {
                    params : {
                              where:{
                                  awardId: this.$route.params.id, 
                                  subid: this.$route.params.subid,
                                  year: this.form.year
                              }, 
                              countPerPage: this.countPerPage, 
                              currentPage: this.currentPage
                            }
                };
                this.$http.get('/api/awards/thisdata',this.getListParams).then(
                    response => {
                          this.data = response.body.listArr;
                          this.total = response.body.count;
                    },
                    response => {
                      console.log('failed');
                    }
                  );
              }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Thissub.vue